var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsWifiOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#dc3545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m787.85-53.37-371.94-373.7q-47 11.24-86.06 32.65-39.07 21.4-70.35 53.44L170-432q31.28-31.28 67.33-54.92 36.04-23.65 77.08-41.65l-84.5-84.5q-40.52 21.48-74.94 46.15-34.43 24.66-65.95 55.94L0-602q31.04-31.04 65.18-56.54 34.15-25.5 71.47-47.55l-83.28-83.28L112-848l736 736-60.15 58.63ZM480-120q-42 0-71-29.5T380-220q0-42 29-71t71-29q42 0 71 29t29 71q0 41-29 70.5T480-120Zm238.63-240.63-28.52-28.52-28.52-28.52L520.22-558.8q80.04 8.71 148.63 41.47Q737.43-484.57 790-432l-71.37 71.37Zm152.35-150.35q-77-76.04-176.47-118.82-99.47-42.79-214.51-42.79-17.89 0-34.64 1.14-16.75 1.15-33.88 3.67L302.07-777.2q44-12 87.46-17.4Q433-800 480-800q142 0 264.76 53Q867.52-694 960-601.52l-89.02 90.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWifiOff);
export default __webpack_public_path__ + "static/media/icons_wifi_off.b0b5b6e0e26bb555cfb0d7a90422b932.svg";
export { ForwardRef as ReactComponent };